<template lang="pug">
div
    el-dialog(
        :visible.sync='show',
        width='80%',
        align-center,
        :before-close='handleCloseModal',
        :close-on-click-modal='false',
        :fullscreen='false',
        append-to-body,
        destroy-on-close
    )
        span(slot='title')
            h1 {{ $t('mensagens.configuracaoRastreabilidade.configuracaoParametros.listagem.modalVisualizarExcecoes.titulo') }}
        .modal-body
            .bloco-listagem-excecoes
                span {{ $t('mensagens.configuracaoRastreabilidade.configuracaoParametros.listagem.modalVisualizarExcecoes.municipio') }}
                .bloco-pesquisa
                    .bloco-pesquisa-input
                        .bloco-pesquisa__icon
                            i.el-icon-search
                        .bloco-pesquisa__input
                            input.input-search(
                                v-model='filtro.nome',
                                type='text',
                                :placeholder='$t("mensagens.configuracaoRastreabilidade.configuracaoParametros.listagem.modalVisualizarExcecoes.busquePeloMunicipio")',
                                autocomplete='off',
                                @keyup.enter='buscarExcecoes(1)'
                            )
                    .bloco-pesquisa__btn
                        el-button(
                            size='large',
                            type='primary',
                            style='width: 180px',
                            @click='buscarExcecoes(1)'
                        ) {{ $t('mensagens.configuracaoRastreabilidade.configuracaoParametros.listagem.modalVisualizarExcecoes.buscar') }}
                .bloco-tabela-excecoes
                    el-table(:key="listagemTableKey('excecoes', excecoes, paginacao.pagina + 1)", :data='excecoes')
                        el-table-column(
                            prop='nome',
                            :label='$t("mensagens.configuracaoRastreabilidade.configuracaoParametros.listagem.modalVisualizarExcecoes.municipio")'
                        )
                        el-table-column(
                            prop='distanciaRaioKm',
                            :label='$t("mensagens.configuracaoRastreabilidade.configuracaoParametros.listagem.tabela.labels.distancia")'
                        )
                            template(slot-scope='scope')
                                span {{ formatNumber(scope.row.distanciaRaioKm) }}
                        el-table-column(
                            prop='percentualCapacidadeProdutiva',
                            :label='$t("mensagens.configuracaoRastreabilidade.configuracaoParametros.listagem.tabela.labels.percentual")'
                        )
                            template(slot-scope='scope')
                                span {{ formatNumber(scope.row.percentualCapacidadeProdutiva) }}
                        template(slot='empty')
                            el-empty(
                                :description='$t("mensagens.configuracaoRastreabilidade.configuracaoParametros.listagem.tabela.semDados")'
                            )
                    .bloco-paginacao
                        span {{ paginacao.total }} {{ paginacao.total > 1 ? $t('mensagens.configuracaoRastreabilidade.configuracaoParametros.listagem.modalVisualizarExcecoes.municipios') : $t('mensagens.configuracaoRastreabilidade.configuracaoParametros.listagem.modalVisualizarExcecoes.municipioMinusculo') }}
                        el-pagination(
                            background,
                            :page-size='paginacao.itensPorPagina',
                            :current-page.sync='paginacao.pagina + 1',
                            layout='prev, pager, next',
                            :total='paginacao.total',
                            @current-change='mudarPagina'
                        )
</template>

<script>
import ConfiguracaoRastreabilidadeService from '@/services/ConfiguracaoRastreabilidadeService';
import formatters from '@/utils/formatters';

export default {
    name: 'VisualizarExcecoes',
    props: {
        show: {
            type: Boolean,
            required: true,
            default: () => false
        },
        idConfiguracaoRastreabilidade: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            filtro: {
                nome: ''
            },
            pageable: {
                page: 0,
                size: 10
            },
            excecoes: [],
            paginacao: {}
        };
    },
    methods: {
        handleCloseModal() {
            this.filtro.nome = '';
            this.$emit('close');
        },
        async buscarExcecoes(page) {
            this.pageable.page = page - 1;
            if (this.idConfiguracaoRastreabilidade) {
                const { data } =
                    await ConfiguracaoRastreabilidadeService.buscarExcecoesPorIdConfiguracaoEFiltro(
                        this.idConfiguracaoRastreabilidade,
                        this.filtro,
                        this.pageable
                    );

                this.excecoes = data.excecoes;
                this.paginacao = data.paginacao;
            }
        },
        formatNumber(number) {
            if (!number) return '-';
            return formatters.formatNumber(number, 2);
        },
        mudarPagina(page) {
            this.buscarExcecoes(page);
        }
    },
    watch: {
        idConfiguracaoRastreabilidade: function (newValue) {
            if (newValue) {
                this.buscarExcecoes(1);
            }
        }
    }
};
</script>

<style lang="scss">
.modal-body {
    border: 1px solid $default-border-color;
    border-radius: $default-border-radius;
    margin-bottom: 20px;
}

.bloco-pesquisa {
    display: flex;
    gap: 10px;
}

.bloco-pesquisa-input {
    display: flex;
    flex: 1;
    background-color: $white;
    padding: 7px 10px;
    border-radius: $default-border-radius;
    gap: 5px;
    align-items: center;
    border: 1px solid $default-border-color;
}

.bloco-pesquisa__icon i {
    color: $primary;
}

.bloco-pesquisa__input {
    flex: 1;

    input {
        border: 0;
        outline: 0;
        width: 100%;
    }
}

.bloco-tabela-excecoes {
    margin-top: 20px;
}

.bloco-paginacao {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background-color: $white;
    border-radius: 0 0 4px 4px;
    padding: 15px;

    span {
        color: $primary;
        font-weight: bold;
    }
}
</style>
